import './i18n';
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles/global.scss";
import { AppProvider } from "./context/AppProvider";
import { captureBootShell, releaseBootShellWhenPainted } from "./bootShell";
import { initDiag } from "./utils/diag";

// Скрытый режим проверки (?diag=1, utils/diag.ts): стили переключателей ставятся ДО первого кадра, чтобы
// каждая проверка шла с чистой загрузки. Без метки — одно чтение sessionStorage.
initDiag();

// Prerender-снапшоты (SEO, scripts/prerender.mjs) сериализуют документ ЦЕЛИКОМ —
// вместе с портальными узлами в <body> (виджет .gw, его backdrop, шторки).
// Они лежат ВНЕ #root: React их не заменяет, и поверх живого приложения
// оставался «мёртвый виджет-призрак» (без слушателей). Сносим все div вне
// #root ДО createRoot: легитимных там нет (только svg-спрайты и скрипты),
// реактовые порталы появятся позже. Страхует и от старых кэшей снапшотов.
document.querySelectorAll('body > div:not(#root)').forEach((el) => el.remove());

const rootEl = document.getElementById("root")!;
// ПОСЛЕ зачистки призраков и ДО createRoot: тот querySelectorAll снёс бы наш
// слой заодно — он тоже `body > div:not(#root)`.
captureBootShell(rootEl);

releaseBootShellWhenPainted(rootEl);

ReactDOM.createRoot(rootEl).render(
    <BrowserRouter>
      <AppProvider>
        <App />
      </AppProvider>
    </BrowserRouter>
);